export default "__VITE_ASSET__i1uMXBO1__"